<template>
  <div>
    <div class="container-fluid font-sarabun bg-white">
      <div class="row mt-3">
        <div class="col-md-4 text-center p-5 colunm-border-right">
          <h2 class="text-uppercase font-basetheme font-kanit">
            <span class="mdi mdi-numeric-1-circle font-3x font-secondtheme"></span>
            <br />พันธกิจ
          </h2>
          <p class="font-1x font-grey">
            “
            <br />เป็นผู้นำสินค้าและบริการสู่ระดับภูมิภาคและระดับสากล
          </p>
        </div>
        <div class="col-md-4 text-center p-5 colunm-border-right">
          <h2 class="text-uppercase font-basetheme font-kanit">
            <span class="mdi mdi-numeric-2-circle font-3x font-secondtheme"></span>
            <br />พันธกิจ
          </h2>
          <p class="font-1x font-grey">
            “
            <br />เป็นผู้พัฒนาเทคโนโลยีและซอฟต์แวร์เพื่อตอบโจทย์ธุรกิจของคนไทย
          </p>
        </div>
        <div class="col-md-4 text-center p-5">
          <h2 class="text-uppercase font-basetheme font-kanit">
            <span class="mdi mdi-numeric-3-circle font-3x font-secondtheme"></span>
            <br />พันธกิจ
          </h2>
          <p class="font-1x font-grey">
            “
            <br />เป็นผู้ให้คำปรึกษาทางด้านเทคโนโลยีและทางด้านธุรกิจ
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>